import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
//
import Layout from '../../components/Layout';
import ProductCard from '../../components/ProductCard';
import { getLinesheetProducts } from '../../api/services/productService';
import { isTokenExpired, navigateToLogin } from '../../utils';

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 3rem 0;
  width: 100%;
`;

const Content = styled.div`
  width: 90%;
  max-width: 1300px;
`;

const SheetTitle = styled.h1`
  font-size: 1.8rem;
  font-weight: 600;
  text-align: center;
  color: ${(props) => props.theme.colors.primaryText};
  margin-bottom: 30px;
  text-transform: capitalize;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;

  > div {
    width: 100% !important;
    box-sizing: border-box !important;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
`;

const StatusText = styled.div`
  text-align: center;
  padding: 3rem;
  color: #777;
`;

// Line Sheet 공유 링크 페이지 (로그인 필수)
export default function LinesheetPage() {
  const { idLinesheet } = useParams();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.userInfo);

  const [title, setTitle] = useState('');
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    // 로그인 필수 - 미로그인 시 로그인 후 이 페이지로 복귀
    const token = localStorage.getItem('token');
    if (!token || isTokenExpired(token) || userInfo.userId == 0) {
      navigateToLogin(navigate, `/linesheet/${idLinesheet}`);
      return;
    }
    fetchLinesheet();
  }, [idLinesheet]);

  const fetchLinesheet = async () => {
    setLoading(true);
    setNotFound(false);
    try {
      const result = await getLinesheetProducts(idLinesheet, userInfo.idStore);
      if (result.is_success) {
        setTitle(result.title || 'Line Sheet');
        setProductList(result.productList || []);
      } else {
        setNotFound(true);
      }
    } catch (e) {
      setNotFound(true);
    }
    setLoading(false);
  };

  return (
    <Layout>
      <Container>
        <Content>
          {loading ? (
            <StatusText>Loading...</StatusText>
          ) : notFound ? (
            <StatusText>Line sheet not found.</StatusText>
          ) : (
            <>
              <SheetTitle>{title}</SheetTitle>
              {productList.length > 0 ? (
                <Grid>
                  {productList.map((item, index) => (
                    <div key={`linesheet_${item.idStyle}_${index}`}>
                      <ProductCard data={item} />
                    </div>
                  ))}
                </Grid>
              ) : (
                <StatusText>No items in this line sheet.</StatusText>
              )}
            </>
          )}
        </Content>
      </Container>
    </Layout>
  );
}
